import React from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import { Div, Text5, Text2, BigFilledButton, LockIcon } from "components/Base";

const NoPermission = ({ returnPath }) => {
  return (
    <Div
      display="column.center.center"
      bg="gray2"
      p={4}
      style={{
        minHeight: "calc(100vh - 65px)",
        width: "100%",
        padding: "2rem"
      }}
    >
      <Div
        display="column.center.center"
        bg="white"
        p={5}
        borderRadius={2}
        boxShadow="0 2px 4px rgba(0, 0, 0, 0.1)"
        height={300}
        maxWidth={500}
        style={{ width: "100%" }}
      >
        <Div display="row.center.center" textAlign="end" mb={3}>
          <LockIcon color="red9" size={30} mr={1} />
          <Text5 color="red9" fs={3} fw={2}>
            Access Denied
          </Text5>
        </Div>
        <Text2 color="gray" mb={4}>
          You don't have permission to view this page.
        </Text2>
        <Link to={returnPath || "/home"}>
          <BigFilledButton bg="altB5">Return to Home</BigFilledButton>
        </Link>
      </Div>
    </Div>
  );
};

NoPermission.propTypes = {
  returnPath: PropTypes.string
};

NoPermission.defaultProps = {
  returnPath: "/home"
};

export default NoPermission;
